import { Typo } from "../../../../../layout/theme";
import { Inner } from "./styles";

export default function ImportResumeCard({ title, value, danger = false }) {
	return (
		<Inner danger={danger}>
			<Typo type={danger ? "danger" : "mediumGrey"} level={6}>
				{title}
			</Typo>
			<Typo type={danger ? "danger" : "primary"} level={4}>
				{value ?? 0}
			</Typo>
		</Inner>
	);
}
